/**
 * Local diagnostics for PPTX branding / ConfigCat client flags.
 *
 * Enabled when:
 *   - `NODE_ENV === "development"`, or
 *   - `window.__FINSTER_BRAND_DIAG__ = true`, or
 *   - `localStorage.setItem("finster:brand-diag", "1")`
 */

declare global {
  interface Window {
    __FINSTER_BRAND_DIAG__?: boolean;
  }
}

export function isBrandingFlagDiagEnabled(): boolean {
  if (process.env.NODE_ENV === "development") return true;
  try {
    if (typeof window !== "undefined" && window.__FINSTER_BRAND_DIAG__) return true;
    if (typeof localStorage !== "undefined" && localStorage.getItem("finster:brand-diag")) return true;
  } catch {
    // ignore
  }
  return false;
}

export function maskSdkKey(sdkKey: string): string {
  if (!sdkKey) return "(empty)";
  if (sdkKey.length <= 12) return "***";
  return `${sdkKey.slice(0, 16)}…${sdkKey.slice(-4)}`;
}

export function logBrandingFlagDiag(event: string, fields: Record<string, unknown> = {}): void {
  if (!isBrandingFlagDiagEnabled()) return;
  console.log("[BrandFlags]", event, fields);
}
